var add = require('./add');


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
module.exports = add(1);



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/inc.js
 ** module id = 3094
 ** module chunks = 0
 **/